import Promise from 'promise-polyfill'

const BusinessTripImposition = {
  namespaced: true,
  state: {
    items: null,
    types: null,
    actives: {}
  },
  mutations: {
    load: (state, payload) => {
      state.items = Object.assign([], payload)
    },
    loadTypes: (state, payload) => {
      state.types = Object.assign(state.types === null ? [] : state.types, payload)
    },
    add: (state, payload) => {
      if (!Array.isArray(state.items)) {
        state.items = []
      }
      state.items.push(payload)
    },
    delete: (state, payload) => {
      state.items = Object.assign([], state.items.filter(x => x.id !== payload.id))
    },
    update: (state, payload) => {
      const index = state.items.findIndex(x => x.id === payload.id)
      if (index >= 0) {
        Object.assign(state.items[index], payload)
      }
    },
    loadActive: (state, payload) => {
      state.actives[payload.category] = Object.assign([], payload.data)
    },
    reset: (state, payload) => {
      state.items = null
      state.types = null
      state.actives = Object.assign({})
    }
  },
  actions: {
    save: (context, payload) => {
      const data = {
        impositionName: payload.item.impositionName,
        impositionType: payload.item.impositionType,
        activation: payload.item.activation,
        remark: payload.item.remark,
        organization: { id: payload.item.organization.id }
      }
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.imposition.insertImpositionUsingPOST({imposition: data})
          .then(res => {
            context.commit('add', res.body)
            resolve(res.body)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    update: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.imposition.updateImpositionUsingPUT({id: payload.item.id, imposition: payload.item})
          .then(res => {
            context.commit('update', res.body)
            resolve(res.body)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    delete: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.imposition.deleteImpositionUsingDELETE({id: payload.item.id})
          .then(res => {
            context.commit('delete', payload.item)
            resolve(payload.item)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    refresh: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.imposition.getImpositionAllUsingGET()
          .then(res => {
            context.commit('load', res.body)
            resolve(res.body)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    refreshActiveList: (context, payload) => {
      const vue = payload.vueinstance
      const category = payload.category === undefined ? 'default' : payload.category.toLowerCase()
      const categories = {
        // FIXME, should get from cached list
        default: vue.$backend.imposition.getImpositionAllUsingGET,
        office: vue.$backend.imposition.getImpositionOfficeActiveUsingGET,
        ship: vue.$backend.imposition.getImpositionShipActiveUsingGET
      }
      return new Promise((resolve, reject) => {
        categories[category]()
          .then(res => {
            context.commit('loadActive', {category: category, data: res.body})
            resolve(res.body)
          })
          .then(err => reject(err))
      })
    },
    list: (context, payload) => {
      if (!context.getters.loaded) {
        return context.dispatch('refresh', payload)
      } else {
        return new Promise((resolve, reject) => {
          if (context.state.items !== null) {
            resolve(context.state.items)
          } else {
            reject(new Error('Can\'t load business trip imposition'))
          }
        })
      }
    },
    typeList: (context, payload) => {
      const vue = payload.vueinstance
      if (!context.getters.typesLoaded) {
        return new Promise((resolve, reject) => {
          vue.$backend.imposition.getImpositionTypeUsingGET()
            .then(res => {
              context.commit('loadTypes', res.body)
              resolve(res.body)
            })
            .catch(err => {
              reject(err)
            })
        })
      } else {
        return new Promise((resolve, reject) => {
          if (context.state.types !== null) {
            resolve(context.state.types)
          } else {
            reject(new Error('Can\'t load business trip imposition types!'))
          }
        })
      }
    },
    getDefaultData: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.imposition.addNewImpositionUsingGET()
          .then(res => {
            resolve(res.body)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    get: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.imposition.getImpositionByIdUsingGET({id: payload.id})
          .then(res => resolve(res.body))
          .then(err => reject(err))
      })
    },
    listActive: (context, payload) => {
      const category = payload.category === undefined ? 'default' : payload.category.toLowerCase()
      if (!context.state.actives.hasOwnProperty(category)) {
        // refresh active list
        return context.dispatch('refreshActiveList', payload)
      } else {
        return new Promise((resolve, reject) => {
          if (context.state.actives.hasOwnProperty(category)) {
            resolve(context.state.actives[category])
          } else {
            reject(new Error('Can\'t load active imposition for ' + category))
          }
        })
      }
    },
    reset: (context, payload) => context.commit('reset')
  },
  getters: {
    loaded: (state) => state.items !== null,
    typesLoaded: (state) => state.types !== null
  }
}

export default BusinessTripImposition



// WEBPACK FOOTER //
// ./src/store/master/BusinessTripImposition.js